// Remember the actual Mobile option, independent of its position or display label.
// Explicit variant/filter URLs take precedence over this browsing preference.
(() => {
  if (window.dfPhonePreferenceBound) return;
  window.dfPhonePreferenceBound = true;

  const normalizePhone = value => String(value || '').trim().toLowerCase();
  function readPhone() {
    const raw = document.cookie.split('; ').find(part => part.startsWith('selectedPhone='))?.slice('selectedPhone='.length);
    if (!raw) return '';
    try { return decodeURIComponent(raw).trim(); } catch { return ''; }
  }
  function remember(phone) {
    if (phone) document.cookie = `selectedPhone=${encodeURIComponent(phone)}; path=/; max-age=86400; SameSite=Lax`;
  }
  function options(picker) {
    try { return JSON.parse(picker?.querySelector('[data-df-phone-options]')?.textContent || 'null'); }
    catch { return null; }
  }

  document.addEventListener('variant:change', event => {
    const variant = event.detail?.variant;
    if (!variant || !(event.target instanceof HTMLFormElement)) return;
    const formId = event.target.getAttribute('id');
    const picker = document.querySelector(`variant-picker[form-id="${CSS.escape(formId || '')}"]`);
    const phoneOption = options(picker);
    if (phoneOption) remember(variant.options?.[phoneOption.position - 1] || variant['option' + phoneOption.position]);
    window.dispatchEvent(new CustomEvent('customVariantChanged', { detail: variant }));
  });

  // Delegated once: filtering replaces the entire section, including its radios.
  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('#phone-model input[type="radio"]')) return;
    remember(input.value);
    const disclosure = input.closest('details');
    if (disclosure) {
      disclosure.open = false;
      disclosure.setAttribute('aria-expanded', 'false');
    }
  }, true);

  async function restore() {
    const params = new URLSearchParams(location.search);
    const filter = document.getElementById('phone-model');
    if (filter?.dataset.dfRestorePhone === 'true') {
      const inputs = [...filter.querySelectorAll('input[type="radio"]')];
      // A filtered link and browser back/forward must retain their explicit state.
      if (!inputs.some(input => params.has(input.name))) {
        const phone = filter.dataset.dfDefaultPhone?.trim() || readPhone();

        const input = inputs.find(input => normalizePhone(input.value) === normalizePhone(phone));
        if (input && !input.disabled) {
          remember(input.value);
          if (!input.checked) input.click();
        }
      }
    }
    if (params.has('variant') || params.has('option_values')) return;
    const phone = readPhone();
    const picker = document.querySelector('variant-picker[context="main_product"]');
    const phoneOption = options(picker);
    const value = phoneOption?.values.find(value => normalizePhone(value.name) === normalizePhone(phone));
    if (!value) return;
    await customElements.whenDefined('variant-picker');
    const input = picker.querySelector(`input[data-option-position="${phoneOption.position}"][value="${CSS.escape(String(value.id))}"]`);
    // An existing sold-out option may be selected: native availability then disables purchase.
    if (input && !input.checked && !input.disabled) input.click();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore, { once: true });
  else restore();
})();
